module.exports = __webpack_public_path__ + "static/media/Water.44daa935.svg";